import * as React from 'react';
import { ControlLabel, Button, Form, DropdownButton, MenuItem } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';

interface IProps {
    categoryNameTranslation: any;
    categories: any;
    allowChange: boolean;
    onCategorySave: (category: number) => void;
}

const ImageProcessingCategorySection = (props: IProps) => {
    return (
        <div className="pull-right">
            {props.categories && props.allowChange && (
                <Form inline>
                    <ControlLabel>
                        {Translate('image-processing/modal/title/label/category')}
                    </ControlLabel>
                    {': '}
                    <DropdownButton
                        title={Translate(props.categoryNameTranslation)}
                        id="bg-nested-dropdown"
                    >
                        {props.categories.map((t: { id: number; name: string }, index: number) => (
                            <MenuItem
                                eventKey={t.id}
                                onClick={() => props.onCategorySave(t.id)}
                                key={'category-item-' + index}
                            >
                                {Translate(t.name)}
                            </MenuItem>
                        ))}
                    </DropdownButton>
                </Form>
            )}
        </div>
    );
};

export default ImageProcessingCategorySection;
